import {isMobile} from 'react-device-detect';
import React, {useEffect} from "react";
import {useSearchParams} from "react-router-dom";
import apiInstance from "../common/ApiInstance";
import {Box, CircularProgress, Typography} from "@mui/material";
import CssBaseline from "@mui/material/CssBaseline";

export default function RedirectPage() {
    const [searchParams] = useSearchParams();
    // let url = searchParams.get("url") || "";
    let id = searchParams.get("id") || "";

    useEffect(() => {
        if (!id) return;

        apiInstance.get(`/api/article/` + id).then(it => {
            let url = (
                isMobile && it.data.mobileHost && it.data.mobileHost.trim() !== ''
                    ? it.data.mobileHost
                    : it.data.host
            ) + it.data.href;
            window.location.replace(url.toString());
        })

    }, [id]);

    return (
        <>
        <CssBaseline/>
        <Box
            sx={{
                position: 'fixed',
                inset: 0,
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                width: '100%',
                backgroundColor: 'action.selected',
                gap: 0,
                textAlign: 'center',
                overflow: 'hidden',
                fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif'
            }}
        >
            <Box
                sx={{
                    width: 160,
                    height: 142,
                    display: 'grid',
                    gridTemplateRows: '40px 32px 28px 42px',
                    justifyItems: 'center',
                    alignItems: 'center'
                }}
            >
                <img
                    src={'web-app-manifest-192x192.png'}
                    style={{ width: '40px', height: '40px', display: 'block' }}
                    alt="logo"
                />
                <Typography
                    variant="h6"
                    sx={{
                        fontFamily: 'inherit',
                        fontWeight: 'bold',
                        lineHeight: '32px'
                    }}
                >
                    딴짓
                </Typography>

                <Typography
                    variant="body2"
                    color="text.secondary"
                    sx={{
                        fontFamily: 'inherit',
                        lineHeight: '28px'
                    }}
                >
                    이동 중입니다
                </Typography>

                <CircularProgress color="inherit" size={30}/>
            </Box>
        </Box>
        </>
    );
}
